
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from "sonner";
import { performUserSessionCleanup } from '@/utils/auth-cleanup';

export const useSignOut = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSignOut = async () => {
    try {
      console.log('[Sign Out] Starting sign out process');
      
      // Perform comprehensive cleanup before signing out
      performUserSessionCleanup(queryClient);
      
      // Sign out from Supabase
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        console.error('Supabase sign out error:', error);
        toast.error("Sign out failed. Please try again.");
        return;
      }
      
      console.log('[Sign Out] Supabase sign out successful');
      
      // Additional cleanup after sign out to ensure everything is cleared
      setTimeout(() => {
        queryClient.clear();
        console.log('[Sign Out] Final cache clear completed');
      }, 100);
      
      toast.success("Signed out successfully");
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
      toast.error("Sign out failed. Please try again.");
    }
  };

  return { handleSignOut };
};
